import { render } from "./RemoveContributorModal.vue?vue&type=template&id=43e26434&scoped=true"
import script from "./RemoveContributorModal.vue?vue&type=script&lang=js"
export * from "./RemoveContributorModal.vue?vue&type=script&lang=js"

import "./RemoveContributorModal.vue?vue&type=style&index=0&id=43e26434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e26434"]])

export default __exports__